export const DefaultMaximumMruEntries = 15;
export const DefaultDropDownWidth = 272;

export const fontInfoItemKey = '__about_font';
